import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(8),
  },
  placeholder: {
    marginTop: theme.spacing(2),
  },
}));

type Props = {
  loadingMsg: string,
};

const LoadingIndicator = (props: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress />
      <Typography className={classes.placeholder}>
        {props.loadingMsg}
      </Typography>
    </div>
  );
};

export default LoadingIndicator;
